import List from "../List";
import Item from "../Item";

const Expandable = Item;

Expandable.Item = Item;
Expandable.List = List;

export default Expandable;
